// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2tCNA","col":"CardReaderDesc_col__1C4Bi","label":"CardReaderDesc_label__25AxS"};